import { Link } from "react-router-dom";
import type { AnimeItem } from "@/mocks/anime";

export default function AnimeCard({ anime }: { anime: AnimeItem }) {
  return (
    <Link
      to={`/detail/${anime.id}`}
      className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden">
        <img
          src={anime.image}
          alt={`${anime.title} - ${anime.titleEn} 短篇番剧海报`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-background-950/70 px-2.5 py-1 text-xs font-medium text-background-50 backdrop-blur">
          {anime.rating}
        </span>
        <span className="absolute right-3 top-3 rounded-full bg-background-50/85 px-2.5 py-1 text-xs font-medium text-foreground-700 backdrop-blur">
          {anime.season}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">{anime.title}</h3>
        <p className="mt-0.5 truncate text-xs text-foreground-500">{anime.titleEn}</p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {anime.genres.slice(0, 3).map((g) => (
            <span
              key={g}
              className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-900"
            >
              {g}
            </span>
          ))}
        </div>
        <div className="mt-auto flex items-center justify-between pt-4 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            共{anime.episode}集 · 每集{anime.episodeMin}分钟
          </span>
          <span className="flex items-center gap-1 font-medium text-primary-600 transition-transform group-hover:translate-x-0.5">
            去康康 <i className="ri-arrow-right-line"></i>
          </span>
        </div>
      </div>
    </Link>
  );
}